import { IHousingObjectResponse } from '@/types';

export const formatRange = (
  from: number | null | undefined,
  to: number | null | undefined,
  unit = '',
): string | null => {
  if (from == null && to == null) return null;
  if (from != null && to != null && from !== to)
    return `${from}–${to}${unit ? `\u00A0${unit}` : ''}`;
  return `${from ?? to}${unit ? `\u00A0${unit}` : ''}`;
};

export const formatPriceRange = (
  from: number | null | undefined,
  to: number | null | undefined,
  currency = '€',
): string | null => {
  if (from == null && to == null) return null;
  const fmt = (n: number) => n.toLocaleString('de-AT');
  if (from != null && to != null && from !== to)
    return `${currency}\u00A0${fmt(from)}\u00A0–\u00A0${currency}\u00A0${fmt(to)}`;
  return `${currency}\u00A0${fmt((from ?? to)!)}`;
};

const PRICE_ON_REQUEST = 'Preis auf Anfrage';

export const formatProjectCardPrice = (
  item: IHousingObjectResponse,
  monthlyLabel: string,
): string => {
  const p = item.prices;
  if (!p) return '–';
  if (item.sell) {
    if (p.sellPrice && p.sellPrice.trim() !== '') return p.sellPrice;
    return PRICE_ON_REQUEST;
  }
  const rent =
    p.monthlyCosts && p.monthlyCosts.trim() !== ''
      ? p.monthlyCosts
      : p.grossRent && p.grossRent.trim() !== ''
        ? p.grossRent
        : null;
  if (!rent) return PRICE_ON_REQUEST;
  return rent === PRICE_ON_REQUEST ? rent : `${rent} ${monthlyLabel}`;
};
